import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'

import Details from 'components/details'
import _Wrapper from "details_container-Wrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/enter_details/details_container.js?styleId=Wrapper";


const Wrapper = /*#__PURE__*/styled('div', null, {
  displayName: "Wrapper",
  styles: _Wrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown'),
    isTabletUp: useDeviceType('isTabletUp')
  })
})

const DetailsContainer = ({ children, ...restProps }) => {
  const isTablet = useDeviceType('isTablet')

  return (
    <Wrapper {...restProps}>
      <Details flow={isTablet ? 'row' : 'column'}>
        {children}
      </Details>
    </Wrapper>
  )
}

export default DetailsContainer
